/* esm.sh - @internetarchive/ia-dropdown@2.3.0 */
import{__decorate as e}from"/tslib?target=es2022";import{html as n,css as d,LitElement as $}from"/lit@^2.8.0%20||%20^3.3.2?target=es2022";import{property as i,query as v,customElement as C,queryAssignedElements as T}from"/lit@^2.8.0%20||%20^3.3.2/decorators?target=es2022";import{when as h}from"/lit@^2.8.0%20||%20^3.3.2/directives/when?target=es2022";import{svg as B}from"/lit@^2.8.0%20||%20^3.3.2?target=es2022";var b=B`<svg class="caret-up-svg" viewBox="0 0 8 4" xmlns="http://www.w3.org/2000/svg">
<path d="m6.7226499 3.51689722c.22976435.15317623.54019902.0910893.69337525-.13867505.13615665-.20423497.10222882-.47220946-.06836249-.63681849l-.07031256-.05655675-3.2773501-2.18490007-3.2773501 2.18490007c-.22976434.15317623-.29185128.4636109-.13867505.69337524.13615665.20423498.39656688.27598409.61412572.18182636l.07924953-.04315131 2.7226499-1.81402514z"
  fill=""></path>
</svg>`;import{svg as k}from"/lit@^2.8.0%20||%20^3.3.2?target=es2022";var g=k`<svg class="caret-down-svg" viewBox="0 0 8 4" xmlns="http://www.w3.org/2000/svg">
<path d="m6.7226499.58397485c.22976435-.15317623.54019902-.09108929.69337525.13867505.13615665.20423498.10222882.47220947-.06836249.63681849l-.07031256.05655676-3.2773501 2.18490006-3.2773501-2.18490006c-.22976434-.15317623-.29185128-.4636109-.13867505-.69337525.13615665-.20423497.39656688-.27598409.61412572-.18182636l.07924953.04315131 2.7226499 1.81402515z"
fill=""></path>
</svg>`;var t=class extends ${constructor(){super(...arguments),this.open=!1,this.isDisabled=!1,this.displayCaret=!1,this.closeOnSelect=!1,this.openViaButton=!0,this.usePopover=!1,this.includeSelectedOption=!1,this.selectedOption="",this.options=[],this.optionGroup="options",this.optionSelected=()=>{},this.isCustomList=!1,this.hasCustomClickHandler=!1,this.closeOnEscape=!1,this.closeOnBackdropClick=!1,this.boundKeyboardListener=o=>{switch(o.key){case"Escape":case"Esc":this.closeOptions();break;default:break}},this.closeOptions=o=>{o&&o.type==="click"&&o.stopPropagation(),this.open=!1,this.updatePopoverState()}}async firstUpdated(){await new Promise(o=>{setTimeout(o,0)}),this.addEventListener("closeDropdown",this.closeOptions)}willUpdate(o){o.has("open")&&this.updatePopoverState()}disconnectedCallback(){var o;(o=super.disconnectedCallback)===null||o===void 0||o.call(this),this.removeKeyboardListener()}setupKeyboardListener(){this.closeOnEscape&&document.addEventListener("keydown",this.boundKeyboardListener)}removeKeyboardListener(){this.closeOnEscape&&document.removeEventListener("keydown",this.boundKeyboardListener)}get dropdownState(){return this.open?(this.setupKeyboardListener(),"open"):(this.removeKeyboardListener(),"closed")}toggleOptions(){this.open=!this.open,this.updatePopoverState()}updatePopoverState(){var o,r;this.usePopover&&((r=(o=this.dropdownMenu)===null||o===void 0?void 0:o.togglePopover)===null||r===void 0||r.call(o,this.open),this.open&&this.positionDropdownMenu())}positionDropdownMenu(){if(!this.dropdownMenu)return;let o=this.container.getBoundingClientRect();this.dropdownMenu.style.left=`${o.left}px`,this.dropdownMenu.style.top=`${o.bottom}px`,this.dropdownMenu.style.minWidth=`${o.width}px`}mainButtonClicked(){var o;this.openViaButton?this.toggleOptions():(o=this.mainButtonLabelSlotted[0])===null||o===void 0||o.click()}mainButtonKeyDown(o){(o.key==="Enter"||o.key===" ")&&(this.mainButtonClicked(),o.preventDefault())}caretKeyDown(o){(o.key==="Enter"||o.key===" ")&&(this.toggleOptions(),o.preventDefault())}renderOption(o){let{label:r,url:a=void 0,id:p}=o,s,c=this.selectedOption===p?"selected":"";return a?s=n`<a
        href=${a}
        @click=${l=>this.optionClicked(l,o)}
        >${r}</a
      >`:s=n`<button
        @click=${l=>this.optionClicked(l,o)}
      >
        ${r}
      </button>`,n`<li role="menuitem" class=${c}>${s}</li>`}optionClicked(o,r){var a;o.stopPropagation(),this.selectedOption!==r.id&&(this.selectedOption=r.id,this.dispatchEvent(new CustomEvent("optionSelected",{detail:{option:r}})),(a=r.selectedHandler)===null||a===void 0||a.call(r,r)),this.closeOnSelect&&(this.closeOptions(),this.mainButton.focus())}get availableOptions(){return this.includeSelectedOption?this.options:this.options.filter(o=>this.selectedOption!==o.id)}get caretUpTemplate(){return n`
      <span ?hidden=${!this.open} class="caret-up">
        <slot name="caret-up">${b}</slot>
      </span>
    `}get caretDownTemplate(){return n`
      <span ?hidden=${this.open} class="caret-down">
        <slot name="caret-down">${g}</slot>
      </span>
    `}get caretTemplate(){return this.displayCaret?this.openViaButton?n`
        <span class="caret" aria-hidden="true">
          ${this.caretUpTemplate} ${this.caretDownTemplate}
        </span>
      `:n`
      <button
        class="caret"
        aria-labelledby="caret-label"
        aria-haspopup="true"
        aria-expanded=${this.open}
        @click=${h(this.shouldAttachEventHandlers,()=>this.toggleOptions)}
        @keydown=${h(this.shouldAttachEventHandlers,()=>this.caretKeyDown)}
        ?disabled=${this.isDisabled}
      >
        ${this.caretUpTemplate} ${this.caretDownTemplate}
      </button>
    `:n``}get dropdownTemplate(){return this.isCustomList?n`<slot name="list"></slot>`:n`${this.availableOptions.map(o=>this.renderOption(o))}`}get backdropTemplate(){return this.closeOnBackdropClick?this.open?n`
      <div
        id="dropdown-backdrop"
        @keyup=${this.closeOptions}
        @click=${this.closeOptions}
      ></div>
    `:n``:n``}get shouldNestCaretInButton(){return this.openViaButton}get shouldAttachEventHandlers(){return!this.isDisabled&&!this.hasCustomClickHandler}render(){return n`
      <div class="ia-dropdown-group ${this.open?"open":""}">
        <div class="button-row">
          <button
            class="click-main"
            aria-haspopup=${this.openViaButton}
            aria-expanded=${this.open}
            @click=${h(this.shouldAttachEventHandlers,()=>this.mainButtonClicked)}
            @keydown=${h(this.shouldAttachEventHandlers,()=>this.mainButtonKeyDown)}
            ?disabled=${this.isDisabled}
          >
            <span class="sr-only" id="caret-label"
              >Toggle ${this.optionGroup}</span
            >
            <slot name="dropdown-label"></slot>
            ${h(this.shouldNestCaretInButton,()=>this.caretTemplate)}
          </button>
          ${h(!this.shouldNestCaretInButton,()=>this.caretTemplate)}
        </div>

        <ul
          id="dropdown-main"
          class=${this.dropdownState}
          role="menu"
          ?popover=${this.usePopover}
        >
          ${this.dropdownTemplate}
        </ul>

        ${this.backdropTemplate}
      </div>
    `}static get styles(){let o=d`var(--dropdownBorderWidth, 1px)`,r=d`var(--dropdownBorderRadius, 4px)`,a=d`var(--dropdownBorderColor, #fff)`,p=d`var(--dropdownBgColor, #333)`,s=d`var(--dropdownTextColor, #fff)`,c=d`var(--dropdownHoverBgColor, rgba(255, 255, 255, 0.3))`,l=d`var(--dropdownSelectedBgColor, #fff)`,u=d`var(--dropdownMainButtonBgColor, transparent)`,x=d`var(--dropdownTextAlign, inherit)`,y=d`var(--dropdownBackdropZIndex, 1)`,m=d`var(--dropdownListZIndex, 2)`;return d`
      :host {
        display: inline;
        color: ${s};
      }

      svg.caret-up-svg,
      svg.caret-down-svg,
      ::slotted(svg.caret-up-svg),
      ::slotted(svg.caret-down-svg) {
        fill: var(--dropdownCaretColor, #fff);
        vertical-align: middle;
      }

      .button-row {
        display: flex;
        height: 100%;
      }

      button.click-main {
        background: ${u};
        color: inherit;
        padding: var(--dropdownMainButtonPadding, 0px);
        border: var(--dropdownMainButtonBorder, none);
        border-radius: var(--dropdownMainButtonBorderRadius, none);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        flex-wrap: nowrap;
        flex-direction: var(--dropdownMainButtonFlexDirection, row);
      }

      .open button.click-main {
        /* When the dropdown is open, give the buttom the same z-index
           as the dropdown menu, so that it remains clickable despite
           the backdrop. */
        z-index: ${m};
      }

      button.click-main:disabled {
        pointer-events: none;
        cursor: not-allowed;
        opacity: 0.5;
        /* Disable text selection on disabled button */
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
      }

      button.click-main:hover {
        background-color: var(
          --dropdownMainButtonHoverBgColor,
          ${u}
        );
      }

      button.click-main:focus,
      button.click-main:focus-visible {
        background-color: var(
          --dropdownMainButtonFocusBgColor,
          ${u}
        );
      }

      button.click-main:active {
        background-color: var(
          --dropdownMainButtonActiveBgColor,
          ${u}
        );
      }

      button slot[name='dropdown-label'] {
        /* Set var to 0px for column layout */
        padding-right: var(--buttonSlotPaddingRight, 5px);
        display: inline-block;
      }

      .ia-dropdown-group {
        width: inherit;
        height: inherit;
        position: relative;
      }

      .sr-only {
        border: 0 !important;
        clip: rect(1px, 1px, 1px, 1px) !important;
        -webkit-clip-path: inset(50%) !important;
        clip-path: inset(50%) !important;
        height: 1px !important;
        margin: -1px !important;
        overflow: hidden !important;
        padding: 0 !important;
        position: absolute !important;
        width: 1px !important;
        white-space: nowrap !important;
        -webkit-user-select: none !important;
        user-select: none !important;
      }

      .caret {
        /* Maintain centered caret position but with a full-height clickable region */
        display: flex;
        align-self: stretch;
        align-items: center;
        padding: var(--caretPadding, 0px);
      }

      button.caret {
        appearance: none;
        background: none;
        border: none;
        cursor: pointer;
      }

      .caret svg {
        height: var(--caretHeight, 10px);
        width: var(--caretWidth, 20px);
      }

      #dropdown-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: transparent;
        z-index: ${y};
      }

      ul {
        z-index: ${m};
      }

      #dropdown-main.closed {
        visibility: hidden;
        height: 1px;
        width: 1px;
      }

      #dropdown-main {
        position: var(--dropdownListPosition, absolute);
        list-style: none;
        margin: var(--dropdownOffsetTop, 5px) 0 0 0;
        padding: var(--dropdownPadding, 0);
        color: ${s};
        background: ${p};

        font-size: var(--dropdownFontSize, inherit);

        border-top: var(--dropdownBorderTopWidth, ${o});
        border-right: var(--dropdownBorderRightWidth, ${o});
        border-bottom: var(--dropdownBorderBottomWidth, ${o});
        border-left: var(--dropdownBorderLeftWidth, ${o});
        /* Must be after border-width settings for specificity */
        border-style: solid;
        border-color: ${a};

        border-radius: var(
            --dropdownBorderTopLeftRadius,
            ${r}
          )
          var(--dropdownBorderTopRightRadius, ${r})
          var(--dropdownBorderBottomRightRadius, ${r})
          var(--dropdownBorderBottomLeftRadius, ${r});

        white-space: var(--dropdownWhiteSpace, normal);

        /* Prevent top/bottom inner li from overlapping inner border */
        overflow: hidden;
      }

      #dropdown-main li:hover {
        background-color: ${c};
        color: var(--dropdownHoverTextColor, #fff);
        list-style: none;
        cursor: pointer;
      }

      #dropdown-main li:hover:first-child {
        border-top-color: ${c};
      }

      ul#dropdown-main li:hover:last-child {
        border-bottom-color: ${c};
      }

      #dropdown-main li:hover:not(:first-child) {
        border-top: 0.5px solid var(--dropdownHoverTopBottomBorderColor, #333);
      }
      #dropdown-main li:hover:not(:last-child) {
        border-bottom: 0.5px solid
          var(--dropdownHoverTopBottomBorderColor, #333);
      }

      #dropdown-main li.selected:last-child {
        border-bottom-color: ${l};
      }

      #dropdown-main li.selected:first-child {
        border-top-color: ${l};
      }

      #dropdown-main li:hover > *,
      #dropdown-main li:focus-within > * {
        background-color: ${c};
        color: var(--dropdownHoverTextColor, #fff);
      }

      #dropdown-main li.selected > * {
        background-color: ${l};
        color: var(--dropdownSelectedTextColor, #2c2c2c);
      }

      #dropdown-main li {
        background: ${p};
        list-style: none;
        height: 30px;
        cursor: pointer;
        border-bottom: 0.5px solid ${p};
        border-top: 0.5px solid ${p};
      }

      #dropdown-main li button {
        background: none;
        color: inherit;
        border: none;
        font: inherit;
        cursor: pointer;
        outline: inherit;
      }

      #dropdown-main li a {
        text-decoration: none;
        display: block;
        box-sizing: border-box;
      }

      #dropdown-main li:first-child {
        border-top-left-radius: var(--dropdownBorderTopLeftRadius, 4px);
        border-top-right-radius: var(--dropdownBorderTopRightRadius, 4px);
      }

      #dropdown-main li:last-child {
        border-bottom-right-radius: var(--dropdownBorderBottomRightRadius, 4px);
        border-bottom-left-radius: var(--dropdownBorderBottomLeftRadius, 4px);
      }

      /* cover the list with the label */
      #dropdown-main li > * > :first-child {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        align-content: center;
        flex-wrap: nowrap;
        height: 100%;
        padding: var(--dropdownItemPaddingTop, 5px)
          var(--dropdownItemPaddingRight, 10px)
          var(--dropdownItemPaddingBottom, 5px)
          var(--dropdownItemPaddingLeft, 10px);
        box-sizing: border-box;
      }

      #dropdown-main li > * {
        width: 100%;
        height: inherit;
        color: ${s};
        background: var(--dropdownItemButtonBgColor, transparent);
        padding: var(--dropdownItemButtonPadding, 0);
        text-align: ${x};
      }
    `}};e([i({type:Boolean,reflect:!0})],t.prototype,"open",void 0);e([i({type:Boolean,reflect:!0})],t.prototype,"isDisabled",void 0);e([i({type:Boolean})],t.prototype,"displayCaret",void 0);e([i({type:Boolean})],t.prototype,"closeOnSelect",void 0);e([i({type:Boolean})],t.prototype,"openViaButton",void 0);e([i({type:Boolean})],t.prototype,"usePopover",void 0);e([i({type:Boolean})],t.prototype,"includeSelectedOption",void 0);e([i({type:String})],t.prototype,"selectedOption",void 0);e([i({attribute:!1})],t.prototype,"options",void 0);e([i({type:String})],t.prototype,"optionGroup",void 0);e([i({attribute:!1})],t.prototype,"optionSelected",void 0);e([i({type:Boolean,reflect:!0})],t.prototype,"isCustomList",void 0);e([i({type:Boolean,reflect:!0})],t.prototype,"hasCustomClickHandler",void 0);e([i({type:Boolean,reflect:!0})],t.prototype,"closeOnEscape",void 0);e([i({type:Boolean,reflect:!0})],t.prototype,"closeOnBackdropClick",void 0);e([v(".ia-dropdown-group")],t.prototype,"container",void 0);e([v("#dropdown-main")],t.prototype,"dropdownMenu",void 0);e([v(".click-main")],t.prototype,"mainButton",void 0);e([T({slot:"dropdown-label"})],t.prototype,"mainButtonLabelSlotted",void 0);t=e([C("ia-dropdown")],t);import{__decorate as L}from"/tslib?target=es2022";import{html as O,css as S,LitElement as E}from"/lit@^2.8.0%20||%20^3.3.2?target=es2022";import{customElement as I}from"/lit@^2.8.0%20||%20^3.3.2/decorators?target=es2022";var w=class extends E{render(){return O`
      <div class="icon-label-container">
        <slot name="icon"></slot>
        <slot></slot>
      </div>
    `}};w.styles=S`
    :host {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
    }

    :host(.invert-icon-at-hover:hover) slot[name='icon'] {
      filter: invert(1);
    }

    :host(.selected) {
      background-color: var(--selectedBgColor, #fff);
      color: var(--selectedTextColor, #2c2c2c);
    }

    :host(.invert-icon-at-selected.selected) slot[name='icon'] {
      filter: invert(1);
    }

    div.icon-label-container {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
      flex-wrap: nowrap;
      flex-direction: var(--iconLabelFlexDirection, row);
      height: 100%;
    }

    slot[name='icon'] {
      width: var(--iconWidth, 20px);
      margin-right: var(--iconLabelGutterWidth, 10px);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
      flex-wrap: nowrap;
      white-space: nowrap;
      height: 100%;
    }

    /* https://css-tricks.com/flexbox-truncated-text/ */
    ::slotted(div.truncate) {
      display: flex;
      width: var(--labelWidth, 100%);
      text-align: left;
      word-wrap: break-word; /* Important for long words! */
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }

    @supports not (-webkit-line-clamp: 2) {
      ::slotted(div.truncate) {
        min-width: 0;
      }
    }
    @supports (-webkit-line-clamp: 2) {
      ::slotted(div.truncate) {
        min-width: 0;
        display: -webkit-box;
        overflow-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /* Fixed line-height needed to fit unicode and emojis
          https://stackoverflow.com/a/67807146
        */
        line-height: 1.2em;
        /* max-height needed for Safari browser */
        max-height: var(--labelTruncateHeight, 30px);
        max-width: var(--labelWidth, 100%);
      }
    }
  `;w=L([I("ia-icon-label")],w);export{t as IaDropdown,w as IaIconLabel};
//# sourceMappingURL=ia-dropdown.mjs.map